import i18next from 'i18next'
import _ from 'lodash'
import { DeepPartial, FieldErrors, UseFormSetError } from 'react-hook-form'
import validator from 'validator'

import {
  Schema,
  SchemaAdUnitBidderParams,
  SchemaAdUnitBidderProps,
} from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/pages/BidParamsAndConnection/form/schema'
import { AdUnitBidderSlice } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/pages/BidParamsAndConnection/hooks/UseGetAdUnitBidders'
import { ParamsKind } from 'features/globalSetup/pages/Prebid/Bidders/types'
import { AdUnitParameter } from 'features/globalSetup/types/adUnitBidder'
import { getParamTemplate } from './getParamTemplate'

type SchemaSlice = Pick<Schema, 'adUnitBidders'>

export const setFormErrorsFor = ({
  adUnitBidderId,
  adUnitBidders,
  errors,
  kind,
  params,
  setError,
}: {
  adUnitBidderId: AdUnitBidderSlice['id']
  adUnitBidders: AdUnitBidderSlice[]
  errors: FieldErrors<SchemaSlice>
  kind: ParamsKind
  params: DeepPartial<SchemaAdUnitBidderProps['csParams' | 's2sParams']>
  setError: UseFormSetError<SchemaSlice>
}): void => {
  Object.entries(params).forEach(
    ([key, value]: [key: keyof SchemaAdUnitBidderParams, value: number | string | undefined]) => {
      if (value === undefined) return

      const paramTemplate: AdUnitParameter | undefined = getParamTemplate({
        adUnitBidders,
        id: adUnitBidderId,
        kind,
        paramName: key,
      })
      if (paramTemplate === undefined) return

      const { name, required, requiredOff } = paramTemplate

      if (!_.isEmpty(errors)) {
        const alreadyHasError = Boolean(
          errors['adUnitBidders']?.[`${adUnitBidderId}`]?.[`${kind}Params`]?.[`${name}`],
        )
        if (alreadyHasError) return
      }

      const isEmpty: boolean = _.isString(value) && validator.isEmpty(value)

      if (!requiredOff && required && isEmpty) {
        setError(`adUnitBidders.${adUnitBidderId}.${kind}Params.${name}`, {
          message: i18next.t('common:form.error.isRequired'),
        })
      }
    },
  )
}
